import styled from 'styled-components'

export const MainContainer = styled.div`
  width: 100%;

  @media (min-width: 1051px) {
    display: flex;
    justify-content: flex-end;
  }
`

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  padding: 9vh 13.2vh 6.6vh 13.1vh;
  margin-right: -10px;
  width: fit-content;

  background-color: var(--aliceBlueLight);
  border-radius: 10px;
  transition: all 0.3s;

  @media (max-width: 1050px) {
    margin-right: 0px;
    margin-top: 10px;
    padding: 9vh 15px 6.6vh 15px;
    width: 100%;
  }

  @media (min-width: 1700px) {
    margin-right: -20px;
  }

  &.toFront {
    position: relative;
    z-index: 1;
    -webkit-box-shadow: 30px 20px 99px 0px var(--shadowPrimary);
    -moz-box-shadow: 30px 20px 99px 0px var(--shadowPrimary);
    box-shadow: 30px 20px 99px 0px var(--shadowPrimary);
  }
`

export const LogoContainer = styled.div`
  text-align: center;

  img {
    max-width: 25vh;
    max-height: 192px;
    margin: auto;
  }
`

export const Text = styled.span`
  font-family: 'Poppins', sans-serif;
  font-size: 26px;
  line-height: 29px;
  color: var(--text);

  text-align: center;

  max-width: 253px;
  margin: 5vh auto 5vh auto;

  @media (max-width: 1050px) {
    font-size: 18px;
  }

  strong {
    font-weight: 400;
    color: var(--primary);
  }
`

export const SocialContainer = styled.div`
  text-align: center;

  a {
    text-decoration: none;
  }

  svg {
    margin-left: 5px;
    margin-right: 5px;
  }
`
